import request from '@comm/utils/request'

/**
 * 文件上传
 * @param {*} data
 * @returns
 */
export function attestationUploadFile(data) {
	return request({
		url: "/pubsignature/api/signature/upload/v1",
		method: "post",
		headers: {
			"Content-Type": "multipart/form-data"
		},
		data
	});
}

/**
 * 验证
 * @param {*} data
 * @returns
 */
export function fileVerify(params) {
	return request({
		url: `/pubsignature/api/signature/verify/v2`,
		method: "get",
		params
	});
}

/**
 * 验证
 * @param {*} data
 * @returns
 */
export function leavefileVerify(params) {
	return request({
		url: `/pubsignature/api/signature/verify/v1`,
		method: "get",
		params
	});
}

/**
 * @description: 文件打包下载
 */
 export function packZipDownload (data) {
    return request({
      url: `/pubsignature/api/signature/zip_download/v1`,
      method: 'post',
      data,
      responseType: 'blob'
    })
  }
  
  /**
   * @description: 单个下载
   */
  export function downloadUploadFile (params) {
    return request({
      url: `/pubsignature/api/signature/download/v1`,
      method:'get',
      params,
      responseType: 'blob'
    })
  }



// WEBPACK FOOTER //
// ./src/comm/api/document-conversion/attestation.js